<template>
  <div class="layout">
    <i-layout class="main-layout">
      <i-header class="layout-header">
        <side-menu />
      </i-header>
      <i-content class="main-content">
        <slot name="content" />
      </i-content>
      <i-footer>
        <footer-menu />
      </i-footer>
      <i-back-top :height="100" :bottom="100">
        <div class="top"><Icon type="ios-arrow-up" /></div>
      </i-back-top>
    </i-layout>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SideMenu from '../components/side-menu.vue';
import FooterMenu from '../components/footer.vue';

export default @Component({
  name: 'frame-layout',
  components: {
    SideMenu,
    FooterMenu,
  },
})

class Layout extends Vue {
}
</script>
<style scoped lang="less">
.top{
  background-color: rgba(0,0,0,.4);
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  i{
    font-size:40px;
  }
}
.layout {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /deep/.ivu-layout{
    background:none;
  }
  /deep/.ivu-layout-footer{
    padding:0;
  }
  .main-layout {
    .layout-header {
      position: absolute;
      width: 100%;
      height: 80px;
      line-height:80px;
      background:none;
      z-index:10;
      .header-title {
        padding: 0 21px;
        height: 80px;
        line-height: 80x;
        font-weight:600;
        font-size: 19px;
        color:rgba(103,55,248,1);
        letter-spacing: 10px;
      }
    }
  }
}
</style>
